import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { downloadCsv, downloadExcel, type ExportRow } from "./export-utils";

interface ExportMenuProps {
  fileName: string;
  rows: ExportRow[];
}

export function ExportMenu({ fileName, rows }: ExportMenuProps) {
  const hasRows = rows.length > 0;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" disabled={!hasRows}>
          <Download className="mr-2 h-4 w-4" />
          Export
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        className="w-44 rounded-md border border-border bg-card p-2 shadow-md"
      >
        <div className="space-y-1">
          <button
            type="button"
            className="block w-full rounded-md px-3 py-2 text-left text-sm hover:bg-muted"
            onClick={() => downloadCsv(rows, fileName)}
          >
            Export CSV
          </button>
          <button
            type="button"
            className="block w-full rounded-md px-3 py-2 text-left text-sm hover:bg-muted"
            onClick={() => downloadExcel(rows, fileName)}
          >
            Export Excel
          </button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
